module.exports = __webpack_public_path__ + "img/cameron-henry.14ea0086.png";